import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function Inbox({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>inbox</title>
      <defs>
        <path
          d="M15.6993168,7.03151159e-07 C16.8869814,-0.000809785832 17.9633128,0.69909971 18.4438598,1.78397151 L21.9138598,9.59397151 L21.9222634,9.61276813 C21.9343688,9.64156472 21.9451649,9.67104732 21.9545771,9.7011414 L21.9138598,9.59397151 C21.9355754,9.64284737 21.9532782,9.69325727 21.966862,9.74470161 C21.974415,9.77237384 21.9806369,9.80097206 21.9856079,9.82999742 C21.9878482,9.84399039 21.9898713,9.85738791 21.9916219,9.87082639 C21.9971599,9.91269018 22,9.95601413 22,10.0000014 L22,15.0000007 C22,16.6568557 20.6568542,18.0000007 19,18.0000007 L3,18.0000007 C1.34314575,18.0000007 0,16.6568557 0,15.0000007 L0,10.0000007 L0.00672773133,9.88338028 C0.00723892697,9.87897905 0.00777870013,9.87458654 0.00834686038,9.87020294 L0,10.0000007 C0,9.94308972 0.00485776341,9.88643617 0.0144455867,9.83064205 C0.0193630597,9.80097206 0.0255849592,9.77237384 0.0330003562,9.74426023 C0.0369587124,9.73023195 0.0411052647,9.71584412 0.0455753133,9.70154924 C0.0548351344,9.67104732 0.065631204,9.64156472 0.0777366214,9.61276813 C0.0804306569,9.60700929 0.0832498864,9.60047681 0.0861402057,9.59397151 L3.55593435,1.78443484 C4.03706177,0.698856167 5.11322515,-0.000809644686 6.3,7.03151159e-07 L15.6993168,7.03151159e-07 Z M2,15.0000009 C2,15.5522862 2.44771525,16.0000009 3,16.0000009 L19,16.0000009 C19.5522847,16.0000009 20,15.5522862 20,15.0000009 L20,11.0000007 L15.5351838,11.0000014 L13.8320503,13.5547016 C13.6465845,13.8329003 13.3343532,14.0000014 13,14.0000014 L9,14.0000014 C8.66564681,14.0000014 8.35341548,13.8329003 8.16794971,13.5547016 L6.46481624,11.0000014 L2,11.0000007 L2,15.0000009 Z M15.7,2.00000094 L6.29931679,2.00000094 C5.90342859,1.9997307 5.54465145,2.23303386 5.38431679,2.59500117 L2.538,9.0000007 L7,9.00000141 C7.29255904,9.00000141 7.56818103,9.12793821 7.75676287,9.34629379 L7.83205029,9.44530121 L9.53518376,12.0000014 L12.4648162,12.0000014 L14.1679497,9.44530121 C14.3534155,9.16710254 14.6656468,9.00000141 15,9.00000141 L19.461,9.0000007 L16.6156832,2.59500117 C16.4553485,2.23303386 16.0965714,1.9997307 15.7,2.00000094 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-387, -461)">
          <g id="inbox" transform="translate(388, 464)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-1, -3)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
